import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({});
export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    instrumentationKey: process.env.REACT_APP_AI_INSTRUMENTATION_KEY,
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();
